import { Region, Province, Commune, Departement, GroupeClient, Typologie, User } from '../types';
import api from './config';

export const referenceApi = {
  // Regions
  getRegions: async (): Promise<Region[]> => {
    const response = await api.get('/api/regions/');
    return response.data.results || response.data;
  },

  createRegion: async (data: Partial<Region>): Promise<Region> => {
    const response = await api.post('/api/regions/', data);
    return response.data;
  },

  updateRegion: async (id: number, data: Partial<Region>): Promise<Region> => {
    const response = await api.patch(`/api/regions/${id}/`, data);
    return response.data;
  },

  deleteRegion: async (id: number): Promise<void> => {
    await api.delete(`/api/regions/${id}/`);
  },

  // Provinces
  getProvinces: async (): Promise<Province[]> => {
    const response = await api.get('/api/provinces/');
    return response.data.results || response.data;
  },

  getProvincesByRegion: async (regionId: number): Promise<Province[]> => {
    const response = await api.get(`/api/provinces/by_region/?region_id=${regionId}`);
    return response.data;
  },

  createProvince: async (data: Partial<Province>): Promise<Province> => {
    const response = await api.post('/api/provinces/', data);
    return response.data;
  },

  updateProvince: async (id: number, data: Partial<Province>): Promise<Province> => {
    const response = await api.patch(`/api/provinces/${id}/`, data);
    return response.data;
  },

  deleteProvince: async (id: number): Promise<void> => {
    await api.delete(`/api/provinces/${id}/`);
  },

  // Communes
  getCommunes: async (): Promise<Commune[]> => {
    const response = await api.get('/api/communes/');
    return response.data.results || response.data;
  },

  getCommunesByProvince: async (provinceId: number): Promise<Commune[]> => {
    const response = await api.get(`/api/communes/by_province/?province_id=${provinceId}`);
    return response.data;
  },

  createCommune: async (data: Partial<Commune>): Promise<Commune> => {
    const response = await api.post('/api/communes/', data);
    return response.data;
  },

  updateCommune: async (id: number, data: Partial<Commune>): Promise<Commune> => {
    const response = await api.patch(`/api/communes/${id}/`, data);
    return response.data;
  },

  deleteCommune: async (id: number): Promise<void> => {
    await api.delete(`/api/communes/${id}/`);
  },

  // Departements
  getDepartements: async (): Promise<Departement[]> => {
     const response = await api.get('/api/departements/?page_size=1000');
    return response.data.results || response.data;
  },

  createDepartement: async (data: Partial<Departement>): Promise<Departement> => {
    const response = await api.post('/api/departements/', data);
    return response.data;
  },

  updateDepartement: async (id: number, data: Partial<Departement>): Promise<Departement> => {
    const response = await api.patch(`/api/departements/${id}/`, data);
    return response.data;
  },

  deleteDepartement: async (id: number): Promise<void> => {
    await api.delete(`/api/departements/${id}/`);
  },

  // GroupeClients
  getGroupeClients: async (): Promise<GroupeClient[]> => {
     const response = await api.get('/api/groupe-clients/?page_size=1000');
    return response.data.results || response.data;
  },

  createGroupeClient: async (data: Partial<GroupeClient>): Promise<GroupeClient> => {
    const response = await api.post('/api/groupe-clients/', data);
    return response.data;
  },

  updateGroupeClient: async (id: number, data: Partial<GroupeClient>): Promise<GroupeClient> => {
    const response = await api.patch(`/api/groupe-clients/${id}/`, data);
    return response.data;
  },

  deleteGroupeClient: async (id: number): Promise<void> => {
    await api.delete(`/api/groupe-clients/${id}/`);
  },

  // Typologies
  getTypologies: async (): Promise<Typologie[]> => {
    const response = await api.get('/api/typologies/?page_size=1000');
    return response.data.results || response.data;
  },

  createTypologie: async (data: Partial<Typologie>): Promise<Typologie> => {
    const response = await api.post('/api/typologies/', data);
    return response.data;
  },

  updateTypologie: async (id: number, data: Partial<Typologie>): Promise<Typologie> => {
    const response = await api.patch(`/api/typologies/${id}/`, data);
    return response.data;
  },

  deleteTypologie: async (id: number): Promise<void> => {
    await api.delete(`/api/typologies/${id}/`);
  },

  // Users
  getUsers: async (): Promise<User[]> => {
    const response = await api.get('/api/users/?page_size=1000');
    return response.data.results || response.data;
  },

  createUser: async (data: Partial<User>): Promise<User> => {
    const response = await api.post('/api/users/', data);
    return response.data;
  },

  updateUser: async (id: number, data: Partial<User>): Promise<User> => {
    const response = await api.patch(`/api/users/${id}/`, data);
    return response.data;
  },

  deleteUser: async (id: number): Promise<void> => {
    await api.delete(`/api/users/${id}/`);
  },
};